module.exports = __webpack_public_path__ + "static/media/Video.0972df27.svg";